import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_ROLE, UPDATE_ROLE } from 'actions/role';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';

const RoleForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const roleDetail = useSelector((state) => state.role.roleDetail);
  const isLoading = useSelector((state) => state.role.isLoading);

  const addRole = useCallback((data) => {
    dispatch({
      type: CREATE_ROLE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateRole = useCallback((data) => {
    dispatch({
      type: UPDATE_ROLE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const RoleSchema = Yup.object().shape({
    name: Yup.string().required(t('roleForm.name')).strict(true).trim(t('roleForm.space')).max(100, t('roleForm.maxlimit')),
  });

  const initialValues = isEdit
    ? { ...roleDetail }
    : {
        name: '',
      };
  return (
    <React.Fragment>
      <div className="role-form-page__main">
        <Card>
          <div className="role-form-header__block">
            <div className="role-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} {t('roleForm.title')}
              </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#BE210B" onClick={onClose} />
            </div>
          </div>
          <div className="role-form-body__block">
            <div className="role-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={RoleSchema}
                onSubmit={(values, { setSubmitting }) => {
                  delete values.is_hidden;
                  delete values.modules;
                  if (isEdit) {
                    updateRole({ id: values.id, name: values.name });
                  } else {
                    addRole({ name: values.name });
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label={t('roleForm.roleName')}
                          placeholder={t('roleForm.roleName')}
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button className="form_btn cancel____btn" onClick={onClose}>
                        {t('button.cancel')}
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
RoleForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default RoleForm;